import React from 'react';
import Tekstboks from './Tekstboks';
import NyFaneIkon from './NyFaneIkon';
import { Buildings2Icon } from '@navikt/aksel-icons';
import './Underenhet.css';
import { Lenke } from '../../GeneriskeElementer/Lenke';
import { Underenhet as UnderenhetType } from '../../api/enhetsregisteretApi';
import { BodyShort, Heading, HStack, Label } from '@navikt/ds-react';
import { formatOrgNr } from '../../utils/util';
import { KontonummerUnderenhet } from './Kontonummer';

interface Props {
    underenhet: UnderenhetType;
}

const Underenhet = ({ underenhet }: Props) => {
    const adresse = underenhet?.beliggenhetsadresse;
    return (
        <>
            <Tekstboks className="underenhet-navn">
                <Label htmlFor={'underenhet_navn_felt'}>Underenhet</Label>
                <Heading
                    id={'underenhet_navn_felt'}
                    size="medium"
                    level="2"
                    className="underenhet-info__navn"
                >
                    <Buildings2Icon aria-hidden="true" title="underenhet" />
                    {underenhet.navn}
                </Heading>
            </Tekstboks>

            <Tekstboks>
                <Label htmlFor={'underenhet_organisasjonsnummer_felt'}>Organisasjonsnummer</Label>
                <BodyShort id={'underenhet_organisasjonsnummer_felt'}>
                    {formatOrgNr(underenhet.organisasjonsnummer)}
                </BodyShort>
            </Tekstboks>

            <Tekstboks className="underenhet-adresse">
                <Label htmlFor={'underenhet_adresse_felt'}>Beliggenhetsadresse</Label>
                <div id={'underenhet_adresse_felt'}>
                    <BodyShort>{adresse?.adresse ?? ''}</BodyShort>
                    <BodyShort>
                        {adresse?.postnummer ?? ''} {adresse?.poststed ?? ''}
                    </BodyShort>
                </div>
            </Tekstboks>

            <Tekstboks>
                <Lenke
                    href={`https://data.brreg.no/enhetsregisteret/oppslag/underenheter/${underenhet.organisasjonsnummer}`}
                >
                    <span>Flere opplysninger for virksomheten hos Enhetsregisteret</span>
                    <NyFaneIkon />
                </Lenke>
            </Tekstboks>
            <HStack gap="6" align={'start'}>
                <KontonummerUnderenhet underenhet={underenhet} />
            </HStack>
        </>
    );
};

export default Underenhet;
